import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none'
  },
  // RouterLink renders an <a>, which without this picks up the UA link color on
  // the primary AppBar. (Underlines are already off globally via
  // assets/scss/index.scss; textDecoration is repeated so this component does
  // not depend on that.)
  brand: {
    color: 'inherit',
    textDecoration: 'none'
  }
}));

const Topbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="primary"
      position="fixed"
    >
      <Toolbar>
        <RouterLink
          className={classes.brand}
          to="/"
        >
          <Typography
            color="inherit"
            component="span"
            variant="h5"
          >
            FitOn Admin
          </Typography>
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
